import { cn } from "@/utils/cn";
import { memo } from "react";
import NextButton from "../next-button";

interface StepsButtonProps {
  nextPath?: string;
  disabled?: boolean;
  type?: "button" | "submit";
  onClick?: () => void;
}

export const StepsButtons = memo(function StepsButtons({
  nextPath,
  disabled,
  type = "button",
  onClick,
}: StepsButtonProps) {
  const showNextButton = nextPath || onClick || type === "submit";
  return (
    <div
      className={cn(
        "fixed right-8 bottom-[calc(1rem+var(--safe-area-inset-bottom))] z-[100] flex",
        {
          "justify-end": showNextButton,
        },
      )}
    >
      {showNextButton && (
        <NextButton
          type={type}
          routerLink={type === "button" && onClick === undefined ? nextPath : undefined}
          disabled={disabled}
          onClick={type === "button" ? onClick : undefined}
        />
      )}
    </div>
  );
});
